document.addEventListener("DOMContentLoaded", function () {
  const openModalButtons = document.querySelectorAll('[href="#openModal"]')
  const closeModalButtons = document.querySelectorAll('[href="#close"]')
  const openModal = document.querySelector('#openModal')

  if (openModal && closeModalButtons && openModalButtons) {
    openModalButtons.forEach(openButton => {
      openButton.addEventListener('click', () => {
        openModal.style.visibility = "visible"
        openModal.style.opacity = 1;
        document.body.style.overflow = "hidden";
      })
    })

    closeModalButtons.forEach(closeButton => {
      closeButton.addEventListener('click', () => {
        openModal.style.visibility = "hidden";
        openModal.style.opacity = 0;
        document.body.style.overflow = "initial"
      })
    })

    openModal.addEventListener('click', (event) => {
      if (event.target === openModal) {
        openModal.style.visibility = "hidden";
        openModal.style.opacity = 0;
        document.body.style.overflow = "initial"
      }
    })
  }

});